import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { getOrganizationId } from "../utils/organizationUtils";
import { startAppointmentAutoCancelScheduler } from "../utils/appointmentAutoCancelScheduler";

/**
 * Global (role-agnostic) appointment auto-cancel cron for hospital staff sessions.
 * Runs at 8:00 / 12:00 / 16:00 / 20:00 / 00:00 / 04:00 local time and on app open
 * for the current slot. Cancels yesterday's (and older) incomplete appointments.
 */
const AppointmentAutoCancelScheduler = () => {
  const { isAuthenticated, user } = useAuth();
  const userId = user?.id ?? null;
  const roleName = user?.roleName || user?.role || "";
  const organizationId = user ? getOrganizationId(user) : null;

  useEffect(() => {
    if (!isAuthenticated || !userId) return undefined;

    const role = String(roleName).trim().toLowerCase();
    // Patients only see their own portal — staff session drives org-wide cancel.
    if (role === "patient") return undefined;

    const stop = startAppointmentAutoCancelScheduler({
      organizationId,
    });

    return () => {
      if (typeof stop === "function") stop();
    };
    // Depend on stable ids — not the whole `user` object — so auth/HMR identity
    // churn does not remount the cron and re-fire cancel/reminders in a loop.
  }, [isAuthenticated, userId, roleName, organizationId]);

  return null;
};

export default AppointmentAutoCancelScheduler;
